import {tap} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {UserInfoService} from "../../user-info.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private userInfo: UserInfoService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          this.userInfo.clearAndEmitLoginState();
        }
      }
    }));
  }
}
